<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-to-left`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 4a1 1 0 011 1v38a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1h2zm15.669 11.114a1.4 1.4 0 01.331.904V22h20a1 1 0 011 1v2a1 1 0 01-1 1H23v5.982a1.4 1.4 0 01-2.304 1.068l-9.433-7.981a1.4 1.4 0 010-2.138l9.433-7.981a1.4 1.4 0 011.973.164z"/></svg>
</template>
<script>

export default {
  name: 'IconToLeft',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
